module.exports = __webpack_public_path__ + "static/media/onoiwa-extra-1.cb2cca47.png";